import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ConnectionStatus } from "../hooks/useFirebaseConnection";
import { AppHandoffRoute, ScanInProgressRoute } from "../constants/routes";
import { useApp } from "../context/AppContext";
import isEmpty from "lodash/isEmpty";
import { createNavigateWithParams } from "../helpers/navigation";

const redirectStatuses = [
  ConnectionStatus.DISCONNECTED,
  ConnectionStatus.INITIALIZING,
] as const;

const WithActiveFirebaseSessionHOC = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {
    connectionStatus,
    customInsoleValues: {
      leftFootArchHeightData,
      rightFootArchHeightData,
      leftFootSizeData,
      rightFootSizeData,
    },
    connectionScanningFoot,
  } = useApp();

  const hasScannedBothFeet = (() => {
    return (
      !isEmpty(leftFootArchHeightData) &&
      !isEmpty(rightFootArchHeightData) &&
      !isEmpty(leftFootSizeData) &&
      !isEmpty(rightFootSizeData)
    );
  })();

  useEffect(() => {
    if (import.meta.env.VITE_STUB_DATA_FOR_DEVELOPMENT === "true") {
      return;
    }

    if (
      connectionStatus === ConnectionStatus.CONNECTED &&
      Boolean(connectionScanningFoot)
    ) {
      createNavigateWithParams(navigate, searchParams)(ScanInProgressRoute, {
        replace: true,
      });
      return;
    }

    if (
      redirectStatuses.includes(connectionStatus as any) &&
      !hasScannedBothFeet
    ) {
      createNavigateWithParams(navigate, searchParams)(AppHandoffRoute, {
        replace: true,
      });
    }
  }, [
    connectionStatus,
    navigate,
    hasScannedBothFeet,
    searchParams,
    connectionScanningFoot,
  ]);

  return children;
};

export default WithActiveFirebaseSessionHOC;
